import React, { Component } from "react";
import { connect } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";
import NavigationRouter from "./NavigationRouter.jsx";
import NavigationsMenu from "./NavigationsMenu.jsx";

class Navigations extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menuState:true
    };
  }

  componentDidMount() {}
  changeMenuState=()=>{
     this.setState({menuState:!this.state.menuState});
  }
  render() {
    return (
      <Router basename="/FarmShopConnectAdmin">
                  
             <div className="parent-container">
             <NavigationsMenu menuState={this.state.menuState}/>
              <NavigationRouter  menuState={this.state.menuState} changeMenuState={this.changeMenuState}/>
              </div>     

           
      

      </Router>
    );
  }
}

const mapStateToProps = function (state) {
  return {};
};

const mapDispatchToProps = function (dispatch) {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(Navigations);
